
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"VarScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllpayeWhereWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllpayeOrderByOrderByClause"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expire"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allpaye"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"VarScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"VarScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"TypeScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TypeScope"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}}},{"kind":"Argument","name":{"kind":"Name","value":"expire"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expire"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tier_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nopaye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paye_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paye_ref"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montant"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_det"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reste"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status_bank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doc_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nocheque"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_cheque"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nocheque"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_cheque"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modepaiement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taux_avance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmd_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agence_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compte_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"motif"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref_remise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_remise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_effet"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":730}};
    doc.loc.source = {"body":"query (\r\n  $VarScope: Int\r\n  $TypeScope: Int\r\n  $where: QueryAllpayeWhereWhereConditions\r\n  $orderby: [QueryAllpayeOrderByOrderByClause!]\r\n  $expire: Int\r\n) {\r\n  allpaye(\r\n    VarScope: $VarScope\r\n    TypeScope: $TypeScope\r\n    where: $where\r\n    orderBy: $orderby\r\n    expire: $expire\r\n  ) {\r\n    id\r\n    tier_name\r\n    nopaye\r\n    paye_date\r\n    paye_ref\r\n    montant\r\n    ttc_det\r\n    reste\r\n    status_name\r\n    status_bank\r\n    doc_type\r\n    type_paye\r\n    nocheque\r\n    date_cheque\r\n    bank\r\n    nocheque\r\n    date_cheque\r\n    modepaiement\r\n    facture\r\n    type_paye\r\n    operation\r\n    taux_avance\r\n    cmd_id\r\n    agence_id\r\n    agence\r\n    compte_id\r\n    motif\r\n    ref_remise\r\n    date_remise\r\n    date_effet\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
